import {useEffect, useRef} from 'react'

import type {PrettifiedBlock} from './use-prettified-blocks'
import {PrettifiedCodeBlock} from './PrettifiedCodeBlock'
import styles from './PrettifiedBlocksList.module.css'

interface PrettifiedBlocksListProps {
  blocks: PrettifiedBlock[]
  onRemove: (id: string) => void
  onToggleCollapse: (id: string) => void
  onCodeChange: (id: string, code: string) => void
  readOnly?: boolean
}

export function PrettifiedBlocksList({
  blocks,
  onRemove,
  onToggleCollapse,
  onCodeChange,
  readOnly = false,
}: PrettifiedBlocksListProps) {
  const blockElementsRef = useRef<Array<HTMLDivElement | null>>([])
  const prevBlockCountRef = useRef(blocks.length)

  useEffect(() => {
    if (blocks.length > prevBlockCountRef.current) {
      blockElementsRef.current[blocks.length - 1]?.scrollIntoView({behavior: 'smooth', block: 'nearest'})
    }
    prevBlockCountRef.current = blocks.length
  }, [blocks.length])

  return (
    <div className={styles.prettifiedBlocksContainer} role="group" aria-label="Pasted blocks">
      {blocks.map((block, index) => (
        <div
          key={block.id}
          ref={el => {
            blockElementsRef.current[index] = el
          }}
        >
          <PrettifiedCodeBlock
            code={block.code}
            collapsed={block.collapsed}
            onRemove={() => onRemove(block.id)}
            onToggleCollapse={() => onToggleCollapse(block.id)}
            onCodeChange={newCode => onCodeChange(block.id, newCode)}
            readOnly={readOnly}
          />
        </div>
      ))}
    </div>
  )
}
